import SocialCampaigns from './social_campaigns'
import EmailCampaigns from './email_campaigns'
import SocialBatches from './social_batches'
import Subscriptions from './subscriptions'
import Page from '@admin/components/page'
import Workflows from './workflows'
import Overview from './overview'
import Users from './users'
import Forms from './forms'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.advisor.team.title,
  manager: {
    path: `/admin/truevail/agency/advisors/${resources.advisor.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview advisor={ resources.advisor } />
      },
      {
        label: 't(Email Campaigns)',
        path: '/email_campaigns',
        panel: <EmailCampaigns advisor={ resources.advisor } />
      },
      {
        label: 't(Forms)',
        path: '/forms',
        panel: <Forms advisor={ resources.advisor } />
      },
      {
        label: 't(Social Batches)',
        path: '/social_batches',
        panel: <SocialBatches advisor={ resources.advisor } />
      },
      {
        label: 't(Social Campaigns)',
        path: '/social_campaigns',
        panel: <SocialCampaigns advisor={ resources.advisor } />
      },
      {
        label: 't(Subscriptions)',
        path: '/subscriptions',
        panel: <Subscriptions advisor={ resources.advisor } />
      },
      {
        label: 't(Users)',
        path: '/users',
        panel: <Users advisor={ resources.advisor } />
      },
      {
        label: 't(Workflows)',
        path: '/workflows',
        panel: <Workflows advisor={ resources.advisor } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  advisor: `/api/admin/truevail/agency/advisors/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
